<template>
	<v-app-bar app clipped-left color="var(--primary)" elevation="0" class="k-topbar px-3">
		<div v-if="is_mobile" @click="$emit('open-drawer')" id="hamburger-icon" class="button-hamburger"><span></span> <span></span> <span></span></div>
		<v-btn v-if="backLink || checkHistory()" class="align-self-center mr-xl-n10" icon elevation="0" color="var(--white)" @click="goBack()">
			<v-icon icon="mdi-arrow-left"
		/></v-btn>

		<v-container class="topbar-container" :class="is_mobile ? 'pl-0 pr-0 ml-0 ' : 'ml-0'">
			<span :class="!is_mobile ? 'ml-16 pl-3' : 'ml-4'" class="text-white align-self-center topbar-title">
				{{ topbartitle }}
			</span>
		</v-container>
	</v-app-bar>
</template>

<script>

import { hasHistory } from "@/helpers";

export default {
	props: {
		topbartitle: {
			type: String,
			required: false,
		},
		backLink: {
			type: String,
			required: false,
		},
		drawer: Boolean,
	},
	data: () => ({}),
	created() {
		if (window.innerWidth > 768) {
			this.$emit("open-drawer", true);
		}
	},

	methods: {
		checkHistory(){
			return hasHistory()
		},
		goBack() {
			if (hasHistory()) {
				this.$router.back();
			} else {
				this.$router.push(this.backLink);
			}
		},
	},

	computed: {
		is_mobile() {
			return window.innerWidth < 768;
		},
	},
};
</script>
